import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import
{
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Spinner,
  Button,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link, useHistory, useParams } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Components/Common/Loader";
import axiosInstance from "../../axiosConfig";

const ForgetPasswordOrganizerPage = ( props ) =>
{
  document.title = props.t( "Réinitialisation de mot de passe | Takci - Organisateur" );
  const history = useHistory();
  const dispatch = useDispatch();

  //Début code pour get le client sélectionné
  const { tokenParam } = useParams( "tokenParam" );

  const [ showPassword, setShowPassword ] = useState( false );
  const [ changePasswordPart, setchangePasswordPart ] = useState( false );
  const [ errorMsg, setErrorMsg ] = useState( null );
  const [ successMsg, setSuccessMsg ] = useState( null );
  const [ loading, setLoading ] = useState( false );

  const { forgetError, forgetSuccessMsg } = useSelector( ( state ) => ( {
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  } ) );

  useEffect( () =>
  {
    if ( tokenParam )
    {
      // console.log("Token useParam: ", tokenParam);
      const checkToken = async () =>
      {
        try
        {
          const data = axios
            .get( `${process.env.REACT_APP_API_URL}/check-token/?token=${ tokenParam }` )
            .then( ( res ) =>
            {
              // console.log("res: ", res);
              setTimeout( () =>
              {
                setchangePasswordPart( true );
              }, 500 );
            } )
            .catch( ( error ) =>
            {
              console.error( error );
              setErrorMsg( props.t( "Invalid reset link" ) );
              toast.error( props.t( "Invalid reset link" ), { autoClose: 3000 } );
              setchangePasswordPart( false );
            } );
        } catch ( err )
        {
          setchangePasswordPart( false );
          console.error( "Erreur de vérification du Token" );
          setErrorMsg( props.t( "Invalid reset link" ) );
          toast.error( props.t( "Invalid reset link" ), { autoClose: 3000 } );

          history.push( "/login-organizer" );
        }
      };
      checkToken();
    }
  }, [ tokenParam ] );

  // Mettre par défaut à true
  // useEffect(() => {
  //   setchangePasswordPart(true);
  // }, [changePasswordPart]);

  const validationSendMessage = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object( {
      email: Yup.string().required( props.t( "Please Enter Your Email" ) ),
    } ),
    onSubmit: ( values ) =>
    {
      setErrorMsg( null );
      setSuccessMsg( null );
      setLoading( true );

      // console.log("onsubmit values : ", values.email);

      const data = axios
        .post( `${process.env.REACT_APP_API_URL}/requestPasswordReset/`, {
          email: values.email,
        } )
        .then( ( res ) =>
        {
          // console.log("res: ", res);
          setSuccessMsg( props.t( "Reset link sent" ) );
          toast.success( props.t( "Reset link sent" ), { autoClose: 3000 } );
          setTimeout( () =>
          {
            setLoading( false );
          }, 500 );
        } )
        .catch( ( error ) =>
        {
          console.error( error );
          setErrorMsg( props.t( "Failed to send reset link" ) );
          toast.error( props.t( "Failed to send reset link" ), {
            autoClose: 3000,
          } );
          setLoading( false );
        } );
    },
  } );

  const validationChangePassword = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      new_password: "",
      confirm_new_password: "",
    },

    validationSchema: Yup.object( {
      new_password: Yup.string().required(
        props.t( "Please Enter Your New Password" )
      ),
      // confirm_new_password: Yup.string().required( props.t( "Password Confirmation failed" ) ),
      confirm_new_password: Yup.string()
        .oneOf(
          [ Yup.ref( "new_password" ), null ],
          props.t( "Password Confirmation failed" )
        )
        .required( props.t( "Please Confirm Your New Password" ) ),
    } ),

    onSubmit: ( values ) =>
    {
      // console.log("Onsubmit Value: ", values);
      try
      {
        // const passwordUpdatedData = {
        //   old_password: values.old_password,
        //   new_password: values.new_password,
        // }
        const passwordUpdatedData = {
          token: tokenParam,
          newPassword: values.new_password,
        };

        setLoading( true );
        // console.log("Modification du mot de passe: ", passwordUpdatedData);

        // const urlUpdatePassword = "https://stepnode.inawo.pro/resetPassword/"
        const urlUpdatePassword = `${process.env.REACT_APP_API_URL}/resetPassword/`;

        const data = axios
          .post( urlUpdatePassword, passwordUpdatedData )
          .then( ( response ) =>
          {
            // console.log("Response: ", response);
            // dispatch(onUpdateAdmin(updateAdmin));
            validationChangePassword.resetForm();
            toast.success( props.t( "Password changed successfully" ), {
              autoClose: 3000,
            } );
            setTimeout( () =>
            {
              setLoading( false );
              history.push( "/login-organizer" );
            }, 1000 );
          } )
          .catch( ( error ) =>
          {
            setTimeout( () =>
            {
              setLoading( false );
            }, 100 );
            console.error( "Echec de la modification du mot de passe: ", error );
            toast.error( props.t( "Password change failed" ), { autoClose: 3000 } );
          } );

        // console.log("data: ", data);

        setTimeout( () =>
        {
          setLoading( false );
        }, 500 );
      } catch ( error )
      {
        console.error(
          "Erreur pendant la modification de mot de passe: ",
          error
        );

        setLoading( false );
      }
    },
  } );

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={ 12 }>
              <div className="text-center mt-sm-5 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={ logoLight } alt="" height="50" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={ 8 } lg={ 6 } xl={ 5 }>
              <Card className="">
                <CardBody className="p-4">
                  { !changePasswordPart && (
                    <>
                      <div className="text-center">
                        <h5 className="text-primary">
                          { props.t( "Mot de passe oublié ?" ) }
                        </h5>
                        <p className="text-muted">
                          { props.t(
                            "Réinitialisez votre mot de passe avec Takci"
                          ) }
                        </p>

                        <lord-icon
                          src="https://cdn.lordicon.com/rhvddzym.json"
                          trigger="loop"
                          colors="primary:#01064a"
                          className="avatar-xl"
                          style={ { width: "90px", height: "90px" } }
                        ></lord-icon>
                      </div>
                    </>
                  ) }

                  { !errorMsg & !successMsg ? (
                    <Alert
                      className="alert-borderless alert-warning text-center mb-2 mx-2"
                      role="alert"
                    >
                      { props.t(
                        "Enter your e-mail address and instructions will be sent to you"
                      ) }
                      .
                    </Alert>
                  ) : null }

                  <div className="p-2">
                    { errorMsg ? (
                      <Alert color="danger" style={ { marginTop: "13px" } }>
                        { errorMsg }
                      </Alert>
                    ) : null }

                    { successMsg ? (
                      <Alert color="success" style={ { marginTop: "13px" } }>
                        { successMsg }
                      </Alert>
                    ) : null }
                    { !changePasswordPart ? (
                      <>
                        <Form
                          onSubmit={ ( e ) =>
                          {
                            e.preventDefault();
                            validationSendMessage.handleSubmit();
                            return false;
                          } }
                        >
                          <div className="mb-2">
                            <Label className="form-label">
                              { props.t( "Email" ) }
                            </Label>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder={ props.t( "Enter Your Email" ) }
                              type="email"
                              onChange={ validationSendMessage.handleChange }
                              onBlur={ validationSendMessage.handleBlur }
                              value={ validationSendMessage.values.email || "" }
                              invalid={
                                validationSendMessage.touched.email &&
                                  validationSendMessage.errors.email
                                  ? true
                                  : false
                              }
                            />

                            { validationSendMessage.touched.email &&
                              validationSendMessage.errors.email ? (
                              <FormFeedback type="invalid">
                                <div>{ validationSendMessage.errors.email }</div>
                              </FormFeedback>
                            ) : null }
                          </div>

                          <div className="text-center mt-1">
                            <button
                              className="btn w-100 text-white"
                              style={ { backgroundColor: "#01064a" } }
                              type="submit"
                              disabled={ loading ? true : false }
                            >
                              { loading ? (
                                <>
                                  <Loader className="me-2" />{ " " }
                                  { props.t( "loading" ) }...
                                </>
                              ) : null }
                              { props.t( "Envoyer le lien de réinitialisation" ) }
                            </button>
                          </div>
                        </Form>
                      </>
                    ) : (
                      <>
                        <Form
                          onSubmit={ ( e ) =>
                          {
                            e.preventDefault();
                            validationChangePassword.handleSubmit();
                            return false;
                          } }
                        >
                          <Row className="g-2">
                            <Col lg={ 12 }>
                              <div className="mb-3">
                                <Label
                                  htmlFor="new-password-admin"
                                  className="form-label"
                                >
                                  { props.t( "New Password" ) }{ " " }
                                  <span style={ { color: "red" } }>*</span>
                                </Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                  <Input
                                    type={ showPassword ? "text" : "password" }
                                    name="new_password"
                                    id="new_password"
                                    className="form-control"
                                    placeholder={ props.t(
                                      "Enter Your New Password"
                                    ) }
                                    validate={ {
                                      required: { value: true },
                                    } }
                                    onChange={
                                      validationChangePassword.handleChange
                                    }
                                    onBlur={ validationChangePassword.handleBlur }
                                    value={
                                      validationChangePassword.values
                                        .new_password
                                    }
                                    invalid={
                                      validationChangePassword.touched
                                        .new_password &&
                                        validationChangePassword.errors
                                          .new_password
                                        ? true
                                        : false
                                    }
                                  />
                                  { validationChangePassword.touched
                                    .new_password &&
                                    validationChangePassword.errors
                                      .new_password ? (
                                    <FormFeedback type="invalid">
                                      {
                                        validationChangePassword.errors
                                          .new_password
                                      }
                                    </FormFeedback>
                                  ) : null }
                                </div>
                              </div>
                            </Col>

                            <Col lg={ 12 }>
                              <div className="mb-3">
                                <Label
                                  htmlFor="confirm-new-password-admin"
                                  className="form-label"
                                >
                                  { props.t( "Confirm New Password" ) }{ " " }
                                  <span style={ { color: "red" } }>*</span>
                                </Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                  <Input
                                    type={ showPassword ? "text" : "password" }
                                    name="confirm_new_password"
                                    id="confirm_new_password"
                                    className="form-control"
                                    placeholder={ props.t(
                                      "Confirm Your New Password"
                                    ) }
                                    validate={ {
                                      required: { value: true },
                                    } }
                                    onChange={
                                      validationChangePassword.handleChange
                                    }
                                    onBlur={ validationChangePassword.handleBlur }
                                    value={
                                      validationChangePassword.values
                                        .confirm_new_password
                                    }
                                    invalid={
                                      validationChangePassword.touched
                                        .confirm_new_password &&
                                        validationChangePassword.errors
                                          .confirm_new_password
                                        ? true
                                        : false
                                    }
                                  />
                                  { validationChangePassword.touched
                                    .confirm_new_password &&
                                    validationChangePassword.errors
                                      .confirm_new_password ? (
                                    <FormFeedback type="invalid">
                                      {
                                        validationChangePassword.errors
                                          .confirm_new_password
                                      }
                                    </FormFeedback>
                                  ) : null }
                                </div>
                              </div>
                            </Col>

                            <Col lg={ 12 }>
                              <div className="form-check mb-3">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="show-remember-check"
                                  onChange={ () =>
                                    setShowPassword( !showPassword )
                                  }
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="show-remember-check"
                                >
                                  { showPassword
                                    ? props.t( "Hide password" )
                                    : props.t( "Show password" ) }
                                </Label>
                              </div>
                            </Col>

                            <Col lg={ 12 }>
                              <div className="text-center">
                                <Button
                                  disabled={ loading ? true : false }
                                  style={ { backgroundColor: "#01064a" } }
                                  className="btn text-white"
                                  type="submit"
                                >
                                  { loading ? (
                                    <Spinner size="sm" className="me-2" />
                                  ) : null }
                                  { props.t( "Change Password" ) }
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </>
                    ) }
                    <div className="mt-2 text-center">
                      <p className="mb-0">
                        { props.t(
                          "Attendez, je me souviens de mon mot de passe..."
                        ) }
                        <Link
                          to="/login-organizer"
                          color="#01064a"
                          className="ms-2 fw-semibold text-decoration-underline"
                        >
                          { props.t( "Cliquez ici" ) }
                        </Link>
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer closeButton={ false } />
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordOrganizerPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter( withTranslation()( ForgetPasswordOrganizerPage ) );
